export default __webpack_public_path__ + "static/media/Axe_5.dd6587d7.png";